import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'src/shadcn/components/ui/tooltip';
import { cn } from 'src/shadcn/lib/utils';
import { Search } from 'lucide-react';
import * as React from 'react';
import { DashboardCommandMenuContext } from 'src/Components/DashboardCommandMenu/DashboardCommandMenuContext';
import { Button } from 'src/shadcn/components/ui/button';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';

export interface ISidebarSearchButtonProps {}

export const SidebarSearchButton: React.FunctionComponent<
  ISidebarSearchButtonProps
> = props => {
  const commandContext = React.useContext(DashboardCommandMenuContext);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={'outline'}
          size={'icon'}
          className='size-8 h-8 w-8 min-w-8 group-data-[collapsible=icon]:opacity-0'
          onClick={() => {
            commandContext.openMenu();
          }}
        >
          <MagnifyingGlassIcon />
          <span className='sr-only'>Inbox</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <div className='flex gap-3 text-left text-slate-400'>
          <span className='flex-auto text-sm'>Search...</span>
          <kbd className='font-sans text-sm font-semibold'>
            <abbr title='Command' className='text-slate-300 no-underline'>
              ⌘
            </abbr>{' '}
            K
          </kbd>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
